const FlyToDay = (state) => state.FlyToDay

export default {
  FlyToDay
}
